<template>
	<div class="app-menu">
		<Menu />
	</div>
</template>

<script>
import Menu from './components/molecules/Menu.vue'

export default {
	name: 'AppMenu',
	data() {
		return {
			val: 0,
			showModal: true
		}
	},
	components: {
		Menu
	}
}
</script>

<style lang="scss">
@import './main.scss';

/* Styling for wrapper to make our styling work easier, should always be out commented before commiting */
// .app-menu {
// 	background-color: #3E5071;
//     height: 58px;
// }

.app {
	padding-top: 0;
}
</style>
